import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    Button,
    Paper,
    alpha,
    useTheme,
} from '@mui/material';
import {
    Settings as SettingsIcon,
    Link as LinkIcon,
} from '@mui/icons-material';

const ConnectPlatformsCTA = ({
    title = "Link Your Platforms",
    description = "To see analytics and performance rankings, you first need to connect your social media accounts in Settings.",
    buttonText = "Go to Settings"
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 4, md: 8 },
                borderRadius: 8,
                textAlign: 'center',
                background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)}, ${alpha(theme.palette.background.paper, 0.5)})`,
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                backdropFilter: 'blur(10px)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 400,
            }}
        >
            <Box
                sx={{
                    width: 120,
                    height: 120,
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 4,
                    position: 'relative',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: -4,
                        borderRadius: 7,
                        border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
                        animation: 'rotate 20s linear infinite',
                    },
                    '@keyframes rotate': {
                        from: { transform: 'rotate(0deg)' },
                        to: { transform: 'rotate(360deg)' },
                    }
                }}
            >
                <LinkIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />
            </Box>

            <Typography variant="h3" sx={{ fontWeight: 900, mb: 2, letterSpacing: '-0.02em' }}>
                {title}
            </Typography>

            <Typography
                variant="h6"
                sx={{
                    color: 'text.secondary',
                    mb: 5,
                    maxWidth: 540,
                    lineHeight: 1.6,
                    fontWeight: 500
                }}
            >
                {description}
            </Typography>

            <Button
                variant="contained"
                size="large"
                startIcon={<SettingsIcon />}
                onClick={() => navigate('/app/settings')}
                sx={{
                    borderRadius: 4,
                    px: 6,
                    py: 2,
                    fontWeight: 800,
                    fontSize: '1rem',
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    boxShadow: '0 10px 20px -5px rgba(99, 102, 241, 0.4)',
                    textTransform: 'none',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 15px 30px -5px rgba(99, 102, 241, 0.5)',
                    },
                }}
            >
                {buttonText}
            </Button>
        </Paper>
    );
};

export default ConnectPlatformsCTA;
